import * as React from 'react';

import SOVQueriesCollabary from './collabary/SOVQueriesCollabary';
import SOVQueriesConsumerInsights from './consumer-insights/SOVQueriesConsumerInsights';

import { CONSUMER_INSIGHTS } from 'modules/insights/sov/utils/consumer-insights/sov-consumer-insights';

import { __t, applyTranslations } from 'utils/language';

import type {
  SOVGeneralPageType,
  SOVGeneralProps,
  SOVQueryEndpoint,
  SOVQuerySave,
  SOVReport
} from 'modules/insights/sov/types';

import './sov-queries.scss';

applyTranslations(require('./sov-queries.i18n.json'));

type Props = {
  pageType: SOVGeneralPageType,
  report: SOVReport,
  isActionEvent: boolean,
  isInvalidQueriesSelection?: boolean,
  onUpdateReport: (a: SOVGeneralProps) => void,
  onSaveQuery: (a: SOVQuerySave) => void,
  onUpdateQuery: (b: Partial<SOVQueryEndpoint>, a: boolean) => void,
  onDuplicateQuery: (a: SOVGeneralProps) => void,
  onDeleteQuery: (a: SOVGeneralProps) => void
};

class SOVQueries extends React.PureComponent<Props> {
  renderConsumerInsights(): React.ReactNode {
    const {
      report,
      isActionEvent,
      onUpdateReport,
      onSaveQuery,
      onUpdateQuery,
      onDuplicateQuery,
      onDeleteQuery
    } = this.props;

    return (
      <div className="sov-queries__consumer-insights">
        <SOVQueriesConsumerInsights
          report={report}
          isActionEvent={isActionEvent}
          onUpdateReport={onUpdateReport}
          onSaveQuery={onSaveQuery}
          onUpdateQuery={onUpdateQuery}
          onDuplicateQuery={onDuplicateQuery}
          onDeleteQuery={onDeleteQuery}
        />
      </div>
    );
  }

  renderCollabary(): React.ReactNode {
    const {
      report,
      isActionEvent,
      onUpdateReport,
      onSaveQuery,
      onUpdateQuery,
      onDuplicateQuery,
      onDeleteQuery
    } = this.props;

    return (
      <div className="sov-queries__collabary">
        <SOVQueriesCollabary
          report={report}
          isActionEvent={isActionEvent}
          onUpdateReport={onUpdateReport}
          onSaveQuery={onSaveQuery}
          onUpdateQuery={onUpdateQuery}
          onDuplicateQuery={onDuplicateQuery}
          onDeleteQuery={onDeleteQuery}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    const { pageType, isInvalidQueriesSelection } = this.props;

    return (
      <div className="sov-queries">
        {
          pageType === CONSUMER_INSIGHTS
            ? this.renderConsumerInsights()
            : this.renderCollabary()
        }
        {isInvalidQueriesSelection && (
          <div className="form-field__error">
            {__t('sov_queries.errors.no_queries_selected')}
          </div>
        )}
      </div>
    );
  }
}

export default SOVQueries;
